import { queryOptions, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ItemTypeLevelApi } from '@/lib/api/common/itemTypeLevel';
import type { ItemTypeLevel } from '@/lib/api/types/itemType';
import { commonQueryKeys } from '@/lib/query-keys/common';
import { associateById } from '@/lib/utils/common/associateById';

export const itemTypeLevelsQueryOptions = () =>
  queryOptions<ItemTypeLevel[]>({
    queryKey: commonQueryKeys.itemTypeLevels.all,
    queryFn: () => ItemTypeLevelApi.getItemTypeLevels(),
  });

export const useItemTypeLevelsQuery = (options: Partial<UseQueryOptions<ItemTypeLevel[]>> = {}) => {
  return useQuery({
    ...itemTypeLevelsQueryOptions(),
    ...options,
  });
};

export const useItemTypeLevelsByIdQuery = (
  options: Partial<UseQueryOptions<ItemTypeLevel[]>> = {},
) => {
  return useQuery({
    ...itemTypeLevelsQueryOptions(),
    ...options,
    select: associateById,
  });
};
